import { useReducer, useCallback } from 'react';
import { useQuery, useMutation, useDataFetchingClient } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { useDataSourcesContext } from 'automation-ui-formula-editor/data-sources/DataSourcesContext';
import { GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME } from 'automation-ui-formula-editor/data-sources/queries/getPrefixQueries';
import addDataSourceReducer from 'automation-ui-formula-editor/fetch-object-panel/reducer/addDataSourceReducer';
import { convertDataSourceDefinitionToState } from 'automation-ui-formula-editor/fetch-object-panel/utils/convertDataSourceDefinitionToState';
import DataSourceForm from 'automation-ui-formula-editor/fetch-object-panel/containers/DataSourceForm';
import { GET_DATA_SOURCE_BY_PREFIX } from 'automation-ui-formula-editor/data-sources/queries/getPrefixQueries';
import { EDIT_DATA_SOURCE } from 'automation-ui-formula-editor/data-sources/queries/editDataSourceQuery';
import isSaveEnabledValidation from 'automation-ui-formula-editor/fetch-object-panel/utils/isSaveEnabledValidation';
import FetchObjectFooter from 'automation-ui-formula-editor/fetch-object-panel/components/FetchObjectFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditDataSource = ({
  onClose,
  objectTypeFilter,
  dataSourceToEdit
}) => {
  var _data$dataSourceByPre;
  const dataFetchingClient = useDataFetchingClient();
  const {
    flowId,
    flowObjectTypeId
  } = useDataSourcesContext();

  // Fetching the unmutated data source to avoid persisting the generated label
  const {
    data
  } = useQuery(GET_DATA_SOURCE_BY_PREFIX, {
    variables: {
      flowId,
      flowObjectTypeId,
      prefix: dataSourceToEdit.name,
      query: {}
    },
    fetchPolicy: 'cache-only'
  });
  const originalDataSource = (_data$dataSourceByPre = data === null || data === void 0 ? void 0 : data.dataSourceByPrefix.dataSources[dataSourceToEdit.name].dataSourceDefinition) !== null && _data$dataSourceByPre !== void 0 ? _data$dataSourceByPre : dataSourceToEdit;
  const [componentState, dispatch] = useReducer(addDataSourceReducer, originalDataSource, convertDataSourceDefinitionToState);
  const {
    isSaveEnabled,
    saveValidationMessage
  } = isSaveEnabledValidation({
    componentState,
    isOverDataSourceCountLimit: false
  });
  const dataSourceId = dataSourceToEdit.metadata.dataSourceId;
  const [editDataSource, {
    loading: savingDataSource
  }] = useMutation(EDIT_DATA_SOURCE, {
    variables: {
      flowId,
      dataSourceId,
      data: componentState
    },
    onCompleted: () => {
      dataFetchingClient.cache.evict({
        fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
        broadcast: true,
        args: {
          flowId,
          flowObjectTypeId,
          prefix: dataSourceToEdit.name,
          query: {}
        }
      });
      onClose();
    }
  });
  const handleSave = useCallback(() => {
    void editDataSource();
  }, [editDataSource]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(DataSourceForm, {
        componentState: componentState,
        dispatch: dispatch,
        flowObjectTypeId: flowObjectTypeId,
        objectTypeFilter: objectTypeFilter,
        readOnly: false,
        isNewDataSource: false
      })
    }), /*#__PURE__*/_jsx(FetchObjectFooter, {
      onClose: onClose,
      onSave: handleSave,
      isSaving: savingDataSource,
      onSaveDisabled: !isSaveEnabled,
      onSaveDisabledTooltip: saveValidationMessage,
      saveBtnLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.footer.buttons.save-text-edit"
      })
    })]
  });
};
export default EditDataSource;